import {
  Button,
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Switch,
} from '@heroui/react'
import React, {useState} from 'react'

import Box from '@/components/UI/Box/Box'
import Body3 from '@/components/UI/Typography/body3'
import AmyButton from '@/components/UI/AmyButton/AmyButton'
import {Body5, Body6} from '@/components/UI/Typography'

interface CookieModalProps {
  open: boolean
  saveCookieConsent: (arg: boolean) => void
  setOpen: (arg: boolean) => void
}

const CookieModal = ({saveCookieConsent, open, setOpen}: CookieModalProps) => {
  const [check, setCheck] = useState(true)

  return (
    <Modal
      isOpen={open}
      onClose={() => setOpen(false)}
      size="2xl"
      backdrop="blur"
      classNames={{
        backdrop: 'backdrop-opacity-20',
        base: 'border-[#292f46] bg-gradient-to-br from-white to-gray-50 dark:from-gray-900 dark:to-gray-800',
        closeButton: 'hover:bg-white/5 active:bg-white/10',
      }}>
      <ModalContent>
        <ModalHeader>
          <Body3 className="font-bold text-gray-800 dark:text-white">
            İzinler
          </Body3>
        </ModalHeader>

        <ModalBody className="py-2">
          <Box className="flex-col gap-6">
            <Box className="flex-col gap-2">
              <Body6 className="text-gray-600 dark:text-gray-300 leading-relaxed">
                Web sitemiz üç tip çerez tutar. Tercihlerini istediğin zaman
                ayarlayabilirsin. Çerezlerin ne olduğu ve hangi çerezleri
                topladığımız hakkında daha fazla bilgi almak istiyorsan lütfen
                Çerez Politikamızı incele. Ayrıca kişisel verileriniz, çerezlere
                onay vermeniz halinde; saklama ve arşiv faaliyetlerinin
                yürütülmesi amacıyla sınırlı olarak yurt dışında yerleşik üçüncü
                taraf altyapı sağlayıcılar aracılığıyla yurt dışındaki
                sunucularda işlenecektir.
              </Body6>
            </Box>

            <Box className="flex-col gap-4 p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-200 dark:border-gray-700">
              <Box className="justify-between items-center">
                <Body5 className="font-semibold text-gray-800 dark:text-white">
                  Zorunlu Çerezler
                </Body5>
                <Switch
                  isSelected={true}
                  isDisabled
                  size="sm"
                  color="primary"
                  classNames={{
                    wrapper: 'group-data-[selected=true]:bg-primary',
                  }}
                />
              </Box>
              <Body6 className="text-gray-600 dark:text-gray-300 leading-relaxed">
                İşlevsel çerezler, web sitesinin düzgün çalışmasını ve
                tercihlerinizin (ör. dil, bölge) kaydedilmesini sağlayan temel
                çerezlerdir.
              </Body6>
            </Box>

            <Box className="flex-col gap-4 p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-200 dark:border-gray-700">
              <Box className="justify-between items-center">
                <Body5 className="font-semibold text-gray-800 dark:text-white">
                  Analitik Çerezler
                </Body5>
                <Switch
                  isSelected={check}
                  onValueChange={setCheck}
                  size="sm"
                  color="primary"
                  classNames={{
                    wrapper: 'group-data-[selected=true]:bg-primary',
                  }}
                />
              </Box>
              <Body6 className="text-gray-600 dark:text-gray-300 leading-relaxed">
                Analitik çerezler, web sitesi kullanımını analiz etmemize ve
                ziyaretçinin deneyimini iyileştirmemize olanak tanır.
              </Body6>
            </Box>
          </Box>
        </ModalBody>

        <ModalFooter>
          <Box className="gap-3 w-full justify-end">
            <Button
              color="danger"
              variant="light"
              onPress={() => setOpen(false)}
              className="font-medium">
              İptal
            </Button>
            <AmyButton
              color="primary"
              onPress={() => saveCookieConsent(check)}
              className="font-semibold px-6">
              Kaydet
            </AmyButton>
          </Box>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default CookieModal
